import { useMemo } from 'react';
import { useOptInEmailTemplate } from '../queries/useOptInEmailQueries';
import { useSendOptInEmailMutation } from '../queries/useOptInEmailMutations';

interface OptInEmailTemplate {
    subject: string;
    body: string;
    variables: {
        subject: Array<{ name: string; id: string; required: boolean }>;
        body: Array<{ name: string; id: string; required: boolean }>;
    };
}

/**
 * Hook to manage sending opt-in emails to recipients
 * Combines template query and send mutation
 */
export const useSendOptInEmail = () => {
    const { data: templateResponse } = useOptInEmailTemplate();
    const { mutateAsync, isPending } = useSendOptInEmailMutation();

    const templateData: OptInEmailTemplate | null = useMemo(() => {
        if (!templateResponse?.emailTemplates?.opt_in_email_template) {
            return null;
        }

        return {
            subject: templateResponse.emailTemplates.opt_in_email_template.default.subject,
            body: templateResponse.emailTemplates.opt_in_email_template.default.body,
            variables: templateResponse.emailTemplates.opt_in_email_template.variables,
        };
    }, [templateResponse]);

    return {
        sendOptInEmail: mutateAsync,
        isLoading: isPending,
        templateData,
    };
};
